var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"path","d":"M17,6.2,15.8,5,11,9.8,6.2,5,5,6.2,9.8,11,5,15.8,6.2,17,11,12.2,15.8,17,17,15.8,12.2,11Z","transform":"translate(-5 -5)","fill":"#fff","fillRule":"evenodd"}));
}

Close.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = Close;

Close.default = Close;
